import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-96dec862"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "category-action-card" };
const _hoisted_2 = { class: "category-action-card__content" };
const _hoisted_3 = { class: "category-action-card__header" };
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "category-action-card__description" };
const _hoisted_7 = {
    key: 0,
    class: "category-action-card__description-text"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["href"];
const _hoisted_10 = ["src"];
import { computed } from 'vue';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { InsightCardType } from '../types';
import { cardConfigs } from '../config/cardConfigs';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CategoryActionCard',
    props: {
        insight: {}
    },
    setup(__props) {
        const props = __props;
        function handleCardLink() {
            useMixpanelConfig('click_category_action_card_cta');
        }
        const currentConfig = computed(() => {
            const categoryId = props.insight.categoryId;
            return cardConfigs[categoryId];
        });
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t(currentConfig.value.title)), 1),
                        _createVNode(_component_el_tooltip, {
                            content: _ctx.$t(currentConfig.value.tooltip),
                            placement: "bottom",
                            "popper-class": "insights-card__tooltip"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("img", {
                                    src: require(`@/assets/svgs/question-outline.svg`)
                                }, null, 8, _hoisted_4)
                            ]),
                            _: 1
                        }, 8, ["content"])
                    ]),
                    _createElementVNode("div", {
                        class: _normalizeClass([
                            'category-action-card__image',
                            { 'category-action-card__image--large': props.insight.categoryId === _unref(InsightCardType).CART_ABANDONMENT },
                        ])
                    }, [
                        _createElementVNode("img", {
                            src: require(`@/assets/svgs/insights/${currentConfig.value.image}`)
                        }, null, 8, _hoisted_5)
                    ], 2),
                    _createElementVNode("div", _hoisted_6, [
                        (currentConfig.value.hint)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t(currentConfig.value.hint)), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentConfig.value.description, (description, index) => {
                            return (_openBlock(), _createElementBlock("p", {
                                key: index,
                                class: "category-action-card__description-text",
                                innerHTML: _ctx.$t(description)
                            }, null, 8, _hoisted_8));
                        }), 128))
                    ])
                ]),
                _createElementVNode("a", {
                    href: props.insight.link,
                    target: "_blank",
                    class: "category-action-card__btn",
                    rel: "noopener noreferrer",
                    referrerpolicy: "no-referrer-when-downgrade",
                    onClick: handleCardLink
                }, [
                    _createElementVNode("img", {
                        src: require(`@/assets/svgs/rocket-blue.svg`)
                    }, null, 8, _hoisted_10),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('strategic-insights.card.link')), 1)
                ], 8, _hoisted_9)
            ]));
        };
    }
});
